"use client";

import React from "react";

type ObjectLiteral = { [key: string]: any };

/** Context value = site-builder block config for the current component instance. */
export type ISalifyComponentContext = ObjectLiteral & {
  blockName?: string;
  variant?: string;
  props?: ObjectLiteral;
  labels?: ObjectLiteral;
};

export const SalifyComponentContext = React.createContext<ISalifyComponentContext>({} as any);
export const useSalifyComponentContext = () => React.useContext(SalifyComponentContext);
